/* Somebody who only works on their own clients.
 *
 * A technician with a book of regulars stands on the board like everybody else
 * — their column, their squares, their clock — but takes nothing the rotation
 * would hand them. A client who asks for them by name goes to them; a walk-in
 * does not, and nor does a colleague's booking that needs a stand-in.
 *
 * Two places say so, and the day wins:
 *
 *   staff  `tt_staff.own_clients_only` — who they usually are. Set once, in
 *          Settings or the admin app, and off unless somebody turns it on.
 *   day    `tt_day_staff.own_clients_only` — what the desk said about today,
 *          from the right-click on their name. Null when nobody has said
 *          anything, which is "as usual", not "off": a default changed in the
 *          afternoon still reaches a day nobody overrode.
 *
 * Out of the rotation means out of all of it (Kevin, 2026-10-23): not next up,
 * not ranked, not a stand-in or a two-way swap for anybody's booking, not
 * charged a skip for turns going past, and not counted in the floor's number
 * that a late arrival or a skipped colleague is measured against — their own
 * squares are requests, and a floor held down by them would read everybody
 * else as ahead.
 *
 * Pure; this file imports nothing.
 */

/* Whether they are on their own clients today.
 *
 *   staff  { ownClientsOnly } — the roster row, or null.
 *   day    { ownClientsOnly } — today's row, or null. `ownClientsOnly` null or
 *          missing is no word from the desk.
 */
export function ownClientsOnly(staff, day) {
  var today = day ? day.ownClientsOnly : null;
  if (today === true || today === false) return today;
  return !!(staff && staff.ownClientsOnly);
}

/* What today's row should hold after the desk sets it to `on`: null when that
 * is simply their usual, so the day goes back to following the roster, and the
 * choice itself otherwise. */
export function dayValueFor(staff, on) {
  var usual = !!(staff && staff.ownClientsOnly);
  return !!on === usual ? null : !!on;
}

/* The members of `list` the rotation is about — everybody `isOwn` does not
 * claim. A copy, in the order given. */
export function inRotation(list, isOwn) {
  return (list || []).filter(function (s) { return !isOwn(s.id); });
}
